import { render, staticRenderFns } from "./WaveForm.vue?vue&type=template&id=24bc3236&"
import script from "./WaveForm.vue?vue&type=script&lang=js&"
export * from "./WaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports